// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3ofNdhYbOHP_lA0wFhoaIo","col":"diTAgX9FLRXoo4kmPh9-1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtSummaryHeader/style.css
// module id = 1069
// module chunks = 0